var map = {
	"./": [
		77
	],
	"./components/TriviaExitPopup": [
		275,
		7
	],
	"./components/TriviaExitPopup.tsx": [
		275,
		7
	],
	"./icons/CloseIcon": [
		142
	],
	"./icons/CloseIcon.tsx": [
		142
	],
	"./icons/FullIcon": [
		273,
		8
	],
	"./icons/FullIcon.tsx": [
		273,
		8
	],
	"./icons/MenuIcon": [
		276,
		9
	],
	"./icons/MenuIcon.tsx": [
		276,
		9
	],
	"./icons/XIcon": [
		277,
		10
	],
	"./icons/XIcon.tsx": [
		277,
		10
	],
	"./index": [
		77
	],
	"./index.tsx": [
		77
	],
	"./text.style": [
		274,
		11
	],
	"./text.style.ts": [
		274,
		11
	],
	"./types": [
		126
	],
	"./types.ts": [
		126
	],
	"./v1": [
		158,
		2
	],
	"./v1/": [
		158,
		2
	],
	"./v1/index": [
		158,
		2
	],
	"./v1/index.tsx": [
		158,
		2
	],
	"./v2": [
		161,
		1
	],
	"./v2/": [
		161,
		1
	],
	"./v2/index": [
		161,
		1
	],
	"./v2/index.tsx": [
		161,
		1
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 422;
module.exports = webpackAsyncContext;